<template>
  <div class="button-icon">
    <md-button
      v-if="!hideButton"
      :disabled="disabled"
      :class="'btn-' + size"
      :color="'btn-' + color"
      class="btn btn-nonenary"
      @click="emitFunction()"
    >
      <svg-loader
        v-if="iconUrl"
        :src="iconUrl"
        alt="icon"
        class="btn-icon"
      />
      <slot />
    </md-button>
  </div>
</template>

<script>
export default {
  name: 'ButtonIcon',
  props: {
    disabled: {
      default: false,
      type: Boolean
    },
    size: {
      default: 'medium',
      type: String
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    color: {
      default: 'primary'
    },
    iconUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    emitFunction() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
  .button-icon {
    button {
      width: 199px;
      height: 40px !important;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    button:disabled {
      border: 2px solid #757575;
      color: #757575;
    }

    .btn-icon {
      width: 22px;
      height: 22px;
    }
  }

  .button-icon button:hover .btn-icon svg path {
    fill: white;
    transition: 1s;
  }
</style>
